export default {
  message: '',
  email: '',
  active: false,
}
